// extracted by mini-css-extract-plugin
export default {"addNewContainer":"style_addNewContainer__FOcit","cardWrapper":"style_cardWrapper__pMPyK"};